<template>
    <div>
        <app-header :module-navigation="navigation" module-name="Contacts"></app-header>
        <main id="page-main" class="with-tabs">
            <!--
            <nav>
                <div class="title">
                    <h1>Annuaire</h1>
                </div>
                <ul>
                    <li><router-link :to="{ name: 'crm-dashboard' }">Dashboard</router-link></li>
                    <li v-if="$aclInterfaceValidator('weeboxcore.person.view')">
                        <router-link :to="{ name: 'person' }">Contacts</router-link>
                    </li>
                    <li v-if="$aclInterfaceValidator('weeboxcore.company.view')">
                        <router-link :to="{ name: 'company' }">Sociétés</router-link>
                    </li>
                </ul>
            </nav>
            -->
            <router-view></router-view>
        </main>
    </div>
</template>
<script>

    export default {
        name: 'Company',
        data () {
            return {
                navigation: [
                    {
                        route: 'contacts-dashboard',
                        label: 'Dashboard',
                        acl: null
                    },
                    {
                        route: 'person',
                        label: 'Particuliers',
                        acl: 'weeboxcore.person.view'
                    },
                    {
                        route: 'company',
                        label: 'Entreprises',
                        acl: 'weeboxcore.company.view'
                    }
                ]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/contacts/Index.vue